var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"accordion"},_vm._l((_vm.accordionList),function(accordion,index){return _c('li',{key:index,staticClass:"accordion__item"},[_c('AccordionItem',[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(accordion.title))]),_c('span',{domProps:{"innerHTML":_vm._s(accordion.text)}})])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }